"use client";

import type { ResolvedLocale } from "@homeinstead/locale";

import { useLocale } from "~www/components/LocaleProvider";

const SHARED_COPY = {
  answerPendingContinueLabel: "Finding care near you…",
  backLabel: "Back",
  continueLabel: "Continue",
  noOfficesFound: "No offices found.",
  selectOfficePlaceholder: "Select office",
  thankYouTitle: "Thank you",
} as const;

function getStepProgressLabel(position: number, total: number): string {
  return `Step ${position} of ${total}`;
}

type CountryCode = ResolvedLocale["metadata"]["country"]["iso3166Alpha2Lower"];

const POSTAL_CODE_LABELS: Record<CountryCode, string> = {
  ca: "Postal code",
  ie: "Eircode",
  us: "ZIP code",
};

/** The lead flow's built-in copy for the site's country. */
function useCopy() {
  const { metadata } = useLocale();

  return {
    ...SHARED_COPY,
    getStepProgressLabel,
    postalCodeLabel: POSTAL_CODE_LABELS[metadata.country.iso3166Alpha2Lower],
  };
}

export { useCopy };
